// extracted by mini-css-extract-plugin
module.exports = {"eventPageWrapper":"eventPage_eventPageWrapper__70x0A"};